exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-control-label[data-v-44b79bba] {\n  line-height: 24px;\n}\n.custom-switch[data-v-44b79bba] {\n  padding-left: 1.2rem;\n}\n.choose-one.custom-switch[data-v-44b79bba] {\n  padding-left: 0;\n}\n.choose-one .custom-control-label[data-v-44b79bba] {\n  margin-left: 40px;\n}", ""]);

// exports
